<template>
  <div>
    <main-navbar type="9"></main-navbar>
    <div class="container">
      <div>
        <main-menu type="0"></main-menu>
      </div>
      <div class="row">
<!--        <div class="col-sm-3 d-none d-sm-block menu-group">-->
          <left-bar></left-bar>
<!--        </div>-->
        <div class="col-sm-9 col-12 bg-group">
          <div class="mb-3">{{ $t('message').group.group_status_explain }}</div>
          <!--          $store.state.group.group_join_article_list.data-->
          <div>
            <div class="scrollbox"
                 v-infinite-scroll="loadArticle"
                 infinite-scroll-disabled="disabled"
                 infinite-scroll-distance="50">
              <article-list-item
                  v-for="item in articlelists"
                  v-bind:key="item.articleID"
                  v-bind:data="item"
                  type="0">
              </article-list-item>
            </div>
            <div class="text-center py-5" v-if="loading"><!-- loader -->
              <i class="now-ui-icons loader_refresh spin"></i>
            </div>
            <div  v-if="noMore" class="nomore"> --  没有更多内容  -- </div>
          </div>
          <!-- <div v-show="!$route.query.act"> -->
          <!-- <div class="scrollbox" v-infinite-scroll="loadArticle"
            infinite-scroll-disabled="$store.state.group.recommand_group.noMore"
            infinite-scroll-distance="20"> -->
          <!-- <div class="scrollbox">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 px-2"
            >
              <group-card-item
                  v-for="(item,index) in $store.state.group.recommand_group.data"
                  :key="index" :data="item">
              </group-card-item>
            </div>
          </div>
           <p class="text-center py-4" v-show="!$store.state.group.recommand_group.noMore" :click="loadArticle">加载更多内容</p>
          <p class="text-center py-4" v-show="$store.state.group.recommand_group.noMore">没有更多了</p> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MainNavbar from '@/layout/MainNavbar.vue';
import MainMenu from './components/Main/MainMenu';
import ArticleListItem from './components/Main/ArticleListItem';
import {Avatar, Button, Dialog, Menu, MenuItem, Radio, Submenu} from 'element-ui';
import group from '../group.service';
import LeftBar from '@/module/group/user/group/LeftBar.vue';

export default {
  name: 'index-my',
  components: {
    MainNavbar,
    MainMenu,
    ArticleListItem,
    // Avatar,
    // IndexHeader,
    // GroupCardItem,
    [Menu.name]: Avatar,
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [Submenu.name]: Submenu,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Radio.name]: Radio,
    LeftBar,
  },
  watch: {
    '$route.query.act':function(val){
      this.init()
    }
  },
  mounted: function () {
    this.init()
  },
  created() {
    this.loadArticle();
  },
  computed: {
    disabled() {
      return this.loading || this.noMore
    }
  },
  methods: {
    init(){
      this.$store.dispatch('group/getGroupJoinArticleList',0)
    },
    loadArticle() {
      this.loading = true;
      group.group_join_article_list(this.lastID).then(res => {
        if (res.status) {
          this.loadmore(res.data);
          this.articlelists = this.articlelists.concat(res.data);
          this.loading = false;
        }
      })
    },
    // $store.state.group.group_join_article_list.data==this.articlelists;

    // 我加入的群吧
    // getJoining() {
    //   group.group_join_list(0).then(res => {
    //     if (res.status) {
    //       this.joinedgroupList = res.data;
    //       this.selectItem.groupinfoID = this.joinedgroupList.length > 0 ? 0 : -1;
    //       this.getArticleList();
    //     }
    //   });
    // },
    // async getArticleList() {
    //   this.loading.article = true;
    //   let res = this.selectItem.groupinfoID >= 0 ? await group.group_join_article_list(this.selectItem.groupinfoID, this.lastID.article) : "";
    //   let arr = res.data;
    //   if (res.status) {
    //     this.noMore = arr.length < 30 ? true : false;
    //     this.lastID.article = arr.length === 30 ? arr[arr.length - 1].create_date : this.lastID.article;
    //     this.articlelists = this.articlelists.concat(arr);
    //     this.loading.article = false;
    //   }
    // },

    // async getGroup(id)
    // {
    //   let arr = await group.recommand_group(this.lastID.article);
    //   this.hotGroups = arr.data;
    // },

    // getList(res) {
    //   if (res.status) {
    //     let arr = res.data.filter(obj => obj.visible != 0);
    //     ;
    //     this.noMore = arr.length < 30 ? true : false;
    //     this.lastID.article = arr.length === 30 ? arr[arr.length - 1].create_date : this.lastID.article;
    //     if (this.lastID.article == 0) {
    //       this.articleList = [];
    //     }
    //     this.articleList = this.articleList.concat(arr);
    //     this.loading.article = false;
    //     this.articleList.forEach(item => {
    //       if (item.postInfo_postID.title == "") {
    //         item.postInfo_postID.title = this.$t('message').editor.title_ph
    //       }
    //     })
    //   }
    // },
    // addCategory() {
    //   this.$refs['form'].validate((valid) => {
    //     if (valid) {
    //       this.btnDisable = true;
    //       group.group_register(this.form.name, this.form.is_private).then(res => {
    //         if (res.status) {
    //           this.getCategories();
    //         }
    //       })
    //     }
    //   })
    // },
    // group_remove(id)
    // {
    //   group.group_remove(id).then(res => {
    //     if (res.status) {
    //       this.getCategories();
    //     }
    //   })
    // },
// 我创建的
//     getCategories() {
//       return
//       group.group_list().then(res => {
//         if (res.status) {
//           this.creategroupList = res.data;
//         }
//         this.btnDisable = false;
//         this.form.name = '';
//         this.form.is_private = 1;
//         this.dialogFormVisible = false;
//       })
// //     },
//     openDialog(item) {
//       this.item = item
//       this.formTitle = item ? this.$t('message').editor.group_setting_title : this.$t('message').editor.group_new_title;
//       this.form.name = item ? item.name : ''
//       this.form.is_private = item ? item.is_private : 1
//       this.dialogFormVisible = true
//     },
//     submit() {
//       if (this.item !== 0) {
//         this.updateCategory(this.item)
//       } else {
//         this.addCategory()
//       }
//     },

  },
  data() {
    var checkNameSame = (rule, value, callback) => {
      if (this.item == 0) {
        this.creategroupList.forEach(item => {
          if (item.name === value) {
            return callback(new Error(this.$t('message').editor.group_new_error))
          }
        })
      }
      callback()
    }
    return {
      topicID: [],
      user: this.$store.state.user,
      // memberList: this.$store.state.group.memberList,
      userinfo: {},
      groupInfo: {},
      groupinfoID: [],
      selectItem: {groupinfoID: -1},
      joinedgroupList: [],
      articlelists: [],
      noMore: false,
      lastID: [],
      loading: true,
      selectID: 0,
      dialogFormVisible: false,
      btnDisable: false,
      formTitle: '',
      item: 0,
      shiftable: true,
      length: 0,
      // collectionList: [],
    };
  },
  filters: {
    formatDate(time)
    {
      var date = new Date(time)
      ;
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  }
};


</script>
<style>
.noticealert {
  position: absolute;
  right: 16px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #FF3636;
}

.group-leftbar ul {
  list-style: none;
  padding-left: 0;
}


li.left-bar-title i {

  font-size: 29px;
}

li.left-bar-title {
  display: flex;
  vertical-align: middle;
  padding: 15px 20px;

}

.group-leftbar svg.text-primary.lable {
  position: absolute;
  margin-left: 25px;
  margin-top: -46px;
  transform: rotate(34deg)
}

.mobile-avatar {
  margin: 0;
  height: 60px;
  box-shadow: -8px 0px 5px -5px #ececec inset;
}

.mobile-avatar svg {
  margin-left: -18px;
  margin-top: -86px;
  transform: rotate(34deg)
} 

.group-leftbar li.active, .group-leftbar li:hover {
  background-color: aliceblue;
  color: #049dca;
} 

.is-plain {
  color: #02a1dc;
  background: #ffffff;
}

.group-leftbar .register-group li {
  padding: 0;
}


.group-leftbar .register-group li:hover {
  background-color: #fff;
}

.menu-group .el-button--primary.is-plain:hover, .menu-group .el-button--primary.is-plain:focus {
  background-image: linear-gradient(
      -25deg, #00BCD4, #009CDE);
}

</style>